import { styled } from 'stitches.config'

export const Content = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  color: '$accent-black',
})

export const Wrapper = styled('div', {
  width: '$max',
  padding: '$11 $3 $10',

  '@bp1': {
    paddingLeft: '$6',
    paddingRight: '$6',
  },

  '@bp2': {
    padding: '$11 $15',
    $$headerHeight: '80px',
    paddingTop: 'calc($$headerHeight + $7)',
  },
})

export const SitemapLayout = styled('ul', {
  position: 'relative',
  marginTop: '$4',
  '& a': {
    color: '$accent-black',

    '&:hover': {
      color: '$primary-700',
    },

    '&:active': {
      color: '$primary-600',
    },
  },
})

export const SitemapItem = styled('li', {
  listStyleType: 'disc',
  variants: {
    indent: {
      true: {
        marginLeft: '$3',
      },
    },
  },
})
